import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Upload, FileSpreadsheet, Loader2, X, Sparkles } from 'lucide-react';

const UploadStep = ({ file, setFile, loading, onAnalyze, onFileDrop }) => {
  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const validTypes = ['.csv', '.xlsx', '.xls'];
      const isValid = validTypes.some(type => selectedFile.name.toLowerCase().endsWith(type));
      if (!isValid) {
        return;
      }
      setFile(selectedFile);
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <Card className="rounded-2xl border-[#E0D6C8]">
        <CardHeader>
          <CardTitle className="text-xl font-['Manrope'] flex items-center gap-2">
            <Upload className="w-5 h-5 text-[#5C4023]" />
            Upload Your File
          </CardTitle>
          <CardDescription>
            Upload a CSV or Excel file with your resource data. The AI will help map your columns.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div
            onDrop={onFileDrop}
            onDragOver={(e) => e.preventDefault()}
            className={`border-2 border-dashed rounded-2xl p-8 text-center transition-colors ${
              file ? 'border-[#5C4023] bg-[#5C4023]/5' : 'border-[#E0D6C8] hover:border-[#5C4023]/50'
            }`}
          >
            {file ? (
              <div className="space-y-3">
                <FileSpreadsheet className="w-12 h-12 mx-auto text-[#5C4023]" />
                <p className="font-medium text-[#1A1A1A]">{file.name}</p>
                <p className="text-sm text-[#5A5A5A]">{(file.size / 1024).toFixed(1)} KB</p>
                <Button variant="ghost" size="sm" onClick={() => setFile(null)} className="text-[#E07A5F]">
                  <X className="w-4 h-4 mr-1" /> Remove
                </Button>
              </div>
            ) : (
              <div className="space-y-3">
                <Upload className="w-12 h-12 mx-auto text-[#888888]" />
                <p className="text-[#5A5A5A]">Drag and drop your file here, or</p>
                <Label htmlFor="file-upload" className="cursor-pointer">
                  <span className="text-[#5C4023] font-medium hover:underline">browse to upload</span>
                  <Input id="file-upload" type="file" accept=".csv,.xlsx,.xls" onChange={handleFileSelect} className="hidden" data-testid="file-upload-input" />
                </Label>
                <p className="text-xs text-[#888888]">Supports CSV, XLSX, XLS files</p>
              </div>
            )}
          </div>
          
          {file && (
            <Button onClick={onAnalyze} disabled={loading} data-testid="analyze-btn" className="w-full mt-4 bg-[#5C4023] hover:bg-[#4A331C] rounded-full h-12">
              {loading ? (
                <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Analyzing with AI...</>
              ) : (
                <><Sparkles className="w-4 h-4 mr-2" /> Analyze File</>
              )}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default UploadStep;
